import React from 'react';
import Button from './Button';

const UserAgreement = ({ onAccept }) => {
  return (
    <div>
      <h2>User Agreement</h2>
      <p>By using EarnGain, you agree to the following terms:</p>
      <ul>
        <li>You will play mobile games for up to 6 hours a day, 5 days a week.</li>
        <li>You will receive daily payouts for your earnings.</li>
        <li>You will make a weekly payment to EarnGain on Friday for the platform commission.</li>
      </ul>
      <Button onClick={onAccept}>I Agree</Button>
    </div>
  );
};

export default UserAgreement;